import React from 'react'
import { i18nTranslate } from 'src/utils'
import { GoDotFill } from 'react-icons/go'
import { Link } from 'react-router-dom'
import ReactSlick from 'react-slick'
import isEmpty from 'lodash/isEmpty'
import { observer } from 'mobx-react'
import {
  Button,
  Row,
  Col,
  Form,
  Image,
  Container,
  Tabs,
  Tab,
} from 'react-bootstrap'
import { IoIosSearch as SearchIcon } from 'react-icons/io'
import { outFitsContainer } from 'src/models'
import { ProductCard, MetaDecorator } from 'src/views/components'
import {
  OutFitsModel,
  outfitModalState,
} from 'src/views/components/OutfitComponents/OutFitsModel'
import { OutFitsList } from 'src/views/components/OutfitComponents/Outfits'
import { RemoveModal } from 'src/views/components/OutfitComponents/RemoveModal'
import { getCategoryList } from 'src/views/components/OutfitComponents/fixture'
import './styles.scss'
import { setResponsiveValues } from 'src/utils'

@observer
class MyCloset extends React.Component {
  constructor() {
    super()
    if (outFitsContainer.searchOutfitTerm !== '') {
      outFitsContainer.makeGetAllList()
      outFitsContainer.searchOutfitTerm = ''
    }
  }

  componentDidMount() {
    outFitsContainer.getOrders()
    outFitsContainer.getOrders({ filterParams: '', page: 2 })
  }

  handleProductCard = productDetails => {
    return <ProductCard product={productDetails} />
  }
  changeOutfitLayout = () => {
    this.isOutfitsAvailable = !this.isOutfitsAvailable
  }

  handleBlur = async event => {
    const outfitName = event.target.value
    if (outfitName !== outFitsContainer.searchOutfitTerm) {
      outFitsContainer.searchOutfitList(outfitName)
    }
  }

  searchOutfit = event => {
    event.preventDefault()
    const outfitName = event.target.elements.listName.value
    outFitsContainer.searchOutfitTerm = outfitName
    outFitsContainer.searchOutfitList(outfitName)
  }
  renderOutFits = () => {
    return <OutFitsList toggleModal={outfitModalState.toggleModal} />
  }

  renderOrderHistory = orderItems => {
    return (
      <ReactSlick
        slidesToShow={setResponsiveValues(4, 3, 2)}
        slidesToScroll={setResponsiveValues(4, 3, 2)}
        infinite={false}
        dots={true}
        customPaging={() => {
          return (
            <span className="dot-class">
              <GoDotFill size="1.5rem" />
            </span>
          )
        }}>
        {orderItems.map(orderItem => {
          const skuProperties = orderItem?.properties || {}
          const productId = skuProperties.productId || ''
          const imageURL = skuProperties?.imageURL || ''
          const name = orderItem.name
          return (
            <Link
              className="order-item"
              key={skuProperties.skuId}
              to={`/product/${productId}`}>
              <div className="d-flex align-items-center justify-content-center order-images-wrap">
                <Image fluid src={imageURL} className="mw-100 mh-100 " />
              </div>
              <div className="order-item-name text-center">{name}</div>
            </Link>
          )
        })}
      </ReactSlick>
    )
  }

  renderProductByCategory = (category, Products) => {
    return (
      <Tab
        eventKey={category.categoryId}
        key={category.categoryId}
        title={category.name}>
        {Products.length === 0 ? (
          <div className="text-center mt-3">
            {i18nTranslate(
              'outfit.noProductsAvailable',
              'No products available'
            )}
          </div>
        ) : (
          this.renderOrderHistory(Products)
        )}
      </Tab>
    )
  }

  renderHistoryProducts = () => {
    const allOrderProducts = outFitsContainer.orderListItems
    if (!isEmpty(allOrderProducts)) {
      const categoryList = getCategoryList()
      const listItems = categoryList.map(item => {
        const category = item.categoryId

        return this.renderProductByCategory(item, allOrderProducts[category])
      })
      return (
        <Tabs
          defaultActiveKey={categoryList[0].categoryId}
          transition={false}
          id="uncontrolled-tab-example">
          {listItems}
        </Tabs>
      )
    }
  }

  render() {
    const outFitItems = outFitsContainer.outFitsList
    const myAccountMyClosetTitle = i18nTranslate(
      'myAccountMyClosetPage.title',
      'My Closet | Nu Skin'
    )
    return (
      <>
        <MetaDecorator
          title={myAccountMyClosetTitle}
          imageUrl=""
          imageAlt=""
          description="My Closet Page"
          location={this.props}
        />
        <Container className="p-0 m-0 my-closet-page">
          <div className="my-closet-header p-3">
            <h4 className="my-closet-title">
              {i18nTranslate('outfit.myCloset', 'My Closet')}
            </h4>

            <Row className="my-closet-search-form-container">
              <Col lg={6} md={12}>
                <Form
                  className="search-outfit-container position-relative"
                  onSubmit={this.searchOutfit}
                  onBlur={this.handleBlur}>
                  <Form.Control
                    className="search-outfit-input"
                    type="text"
                    name="listName"
                    placeholder={i18nTranslate(
                      'outfits.searchAll',
                      'Search All Outfits'
                    )}
                  />
                  <Button
                    className="position-absolute bg-transparent border-0 p-0 order-search-button"
                    type="submit">
                    <SearchIcon fill="#000" className="outfit-search-icon" />
                  </Button>
                </Form>
              </Col>
              <Col lg={4} md={12}>
                <Button
                  className="new-outfit-button"
                  onClick={() => {
                    outFitsContainer.setNewOutfit()
                    outfitModalState.toggleModal()
                  }}>
                  {i18nTranslate('outfit.newOutfit', 'New Outfit')}
                </Button>
              </Col>
            </Row>
          </div>
          <div className="outfit-wrapper">
            {outFitItems.length === 0 &&
            outFitsContainer.searchOutfitTerm !== '' ? (
              <div>
                {i18nTranslate(
                  'outfit.searchFailure',
                  'No outfits found for the search term'
                )}
                <b>{' ' + outFitsContainer.searchOutfitTerm}</b>
              </div>
            ) : outFitItems.length > 0 ? (
              <>
                <h3 className="mb-4">
                  {i18nTranslate(
                    'outfit.yourOutfits',
                    'Here are your outfit collections'
                  )}
                </h3>
                {this.renderOutFits()}
              </>
            ) : (
              <>
                <h1 className="mb-4">
                  {i18nTranslate('outfit.header', 'Outfits')}
                </h1>
                <div className="closet-container">
                  <p className="outfit-content">
                    {i18nTranslate(
                      'outfit.describe',
                      'Use purchased items or favorites in your closet to create an outfit'
                    )}
                  </p>

                  <Button
                    className="btn-primary start-building-btn"
                    onClick={() => {
                      outFitsContainer.setNewOutfit()
                      outfitModalState.toggleModal()
                    }}>
                    {i18nTranslate('outfit.startBuilding', 'Start Building')}
                  </Button>
                </div>
              </>
            )}
          </div>
          <RemoveModal />
          <OutFitsModel />
          <h3 className="text-center mb-4">
            {i18nTranslate('outfit.purchase', 'Your Purchase History')}
          </h3>
          {this.renderHistoryProducts()}
        </Container>
      </>
    )
  }
}

export { MyCloset }

export default MyCloset
